import { connect } from 'react-redux';
import IAppState from "../../../IAppState";
import JobReportComponent from '../components/JobReportComponent';
import { IJobReportComponentPropsData, IJobReportComponentPropsFunctions } from '../props/IJobReportComponentProps';

const mapStateToProps = ({ jobState }: IAppState): IJobReportComponentPropsData => ({
    calculations: jobState.jobInfo !== null ? jobState.jobInfo.jobCalculations : [],
})

const mapDispatchToProps = (dispatch): IJobReportComponentPropsFunctions => ({
})


const JobReportContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(JobReportComponent)

export default JobReportContainer;
